// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface UniversityIconSignature {
  Element: SVGSVGElement;
}

export const UniversityIcon: TOC<UniversityIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 9.99997H1.99999C1.55099 9.99997 1.15599 9.69997 1.03599 9.26697C0.915986 8.83397 1.09999 8.37397 1.48599 8.14297L11.486 2.14297C11.803 1.95397 12.198 1.95397 12.515 2.14297L22.515 8.14297C22.901 8.37397 23.084 8.83397 22.964 9.26697C22.844 9.69997 22.449 9.99997 22 9.99997ZM23 20H0.999986V22H23V20ZM12 4.16697L18.39 7.99997H5.60999L12 4.16697ZM22 11V13H21V17H22V19H1.99999V17H2.99999V13H1.99999V11H22ZM13 13H15V17H13V13ZM8.99999 17H11V13H8.99999V17ZM4.99999 13H6.99999V17H4.99999V13ZM17 17H19V13H17V17Z"/>
</svg>
</template>;